import api from '@/api/axiosApi'
import type {
  MultilocFullResponse,
  MultilocLinesResponse,
  CreateMultilocRequest,
  UpdateMultilocRequest,
} from '@/components/PlanDetail/MultilocDrawer/types'

export async function fetchMultiloc(
  planId: string,
  versionId: string,
  lineId: string
): Promise<MultilocFullResponse> {
  const response = await api.get<MultilocFullResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/multiloc`
  )
  return response.data
}

export async function createMultiloc(
  planId: string,
  versionId: string,
  lineId: string,
  body: CreateMultilocRequest
): Promise<MultilocFullResponse> {
  const response = await api.post<MultilocFullResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/multiloc`,
    body
  )
  return response.data
}

export async function updateMultiloc(
  planId: string,
  versionId: string,
  lineId: string,
  body: UpdateMultilocRequest
): Promise<MultilocFullResponse> {
  const response = await api.put<MultilocFullResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/multiloc`,
    body
  )
  return response.data
}

export async function deleteMultiloc(
  planId: string,
  versionId: string,
  lineId: string
): Promise<void> {
  await api.delete(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/multiloc`
  )
}

export async function fetchMultilocLines(
  planId: string,
  versionId: string,
  params?: { offset?: number; limit?: number; q?: string }
): Promise<MultilocLinesResponse> {
  const response = await api.get<MultilocLinesResponse>(
    `/plans/${planId}/versions/${versionId}/multiloc/lines`,
    { params }
  )
  return response.data
}

export async function applyMultilocToAll(
  planId: string,
  versionId: string,
  lineId: string
): Promise<MultilocFullResponse> {
  const response = await api.post<MultilocFullResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/multiloc-all`
  )
  return response.data
}
